import { Form } from 'formsy-semantic-ui-react';
import MyTypes from 'MyTypes';
import React from 'react';
import { trackPromise } from 'react-promise-tracker';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Button, Grid } from 'semantic-ui-react';
import { accountActions } from '../../features/account';
import { IUser } from '../../models';
import services from '../../services';
import * as datesHelper from '../../utils/datesHelper';
import { LoadingSpiner } from './../loading-spinner/LoadingSpinner';
import AddLicenseModal from './../register-layout/AddLicenseModal';
import EditLicenseModal from './../register-layout/EditLicenseModal';
import LicenseItem from './../register-layout/LicenseItem';

interface Props {
  checkAuthentication: typeof accountActions.checkAuthentication;
  getSubmitRef: (ref: any) => void;
  user: IUser;
  download: (file: any) => void;
}

interface State {
  licenses: object[];
  licenseId: number | undefined;
  showEditModal: boolean;
}

class ProfileLicenses extends React.Component<Props, State> {
  public state = {
    licenses: [],
    licenseId: 0,
    showEditModal: false,
  };

  public sumbitRef = React.createRef();

  public getLicense = async (item: object, id?: number) => {
    item.issuedDate = datesHelper.parseDateToDateStringWithFormat(item.issuedDate);
    item.expirationDate = datesHelper.parseDateToDateStringWithFormat(item.expirationDate);

    if (item.file.fileType === '') {
      const addLicense = await trackPromise(
        services.api.user.addLicense({
          state: item.state,
          license: item.license,
          issuedDate: item.issuedDate,
          expirationDate: item.expirationDate,
        }),
        'licenses-area'
      );
      if (addLicense.isSuccess) {
        this.showEditLicense(false);
      } else {
        console.error(addLicense);
      }
    } else {
      const resp = await services.api.account.getSignedUrl({
        name: item.file.fileName,
        type: item.file.fileType,
        size: item.file.fileSize,
        public: true,
      });
      if (resp.isSuccess) {
        const data = resp.data.url.fields;
        const obj = Object.assign({}, data, {
          file: item.file.fileInitial,
        });
        const formData = new FormData();
        for (const key in obj) {
          if (undefined === obj[key]) {
            continue;
          }
          formData.append(key, obj[key]);
        }
        const postFile = await trackPromise(
          services.api.file.postFile(resp.data.url.url, formData),
          'licenses-area'
        );
        if (postFile.status === 204) {
          await services.api.user.addLicense({
            state: item.state,
            license: item.license,
            issuedDate: item.issuedDate,
            expirationDate: item.expirationDate,
            fileObjectKey: resp.data.url.fields.key,
          });
        } else {
          console.error(postFile);
        }
      } else {
        console.error(resp);
      }
    }

    this.listLicenses();
  };

  public deleteLicense = async (id: number) => {
    await services.api.user.removeLicense(id);
    const { licenses } = this.state;
    const index = licenses.findIndex(el => el.id === id);
    licenses.splice(index, 1);
    this.setState({ licenses }, this.listLicenses);
  };

  public editLicense = async (id: any, item: any) => {
    item.issuedDate = datesHelper.parseDateToDateStringWithFormat(item.issuedDate);
    item.expirationDate = datesHelper.parseDateToDateStringWithFormat(item.expirationDate);

    if (item.file.fileType === '') {
      const updateLicense = await services.api.user.updateLicense(id, {
        state: item.state,
        license: item.license,
        issuedDate: item.issuedDate,
        expirationDate: item.expirationDate,
      });
      if (updateLicense.isSuccess) {
        this.showEditLicense(false);
      }
    } else if (item.file.fileKey && !item.file.fileInitial) {
      const updateLicense = await services.api.user.updateLicense(id, {
        state: item.state,
        license: item.license,
        issuedDate: item.issuedDate,
        expirationDate: item.expirationDate,
        fileObjectKey: item.file.fileKey,
      });
      if (updateLicense.isSuccess) {
        this.showEditLicense(false);
      }
    } else {
      const resp = await services.api.account.getSignedUrl({
        name: item.file.fileName,
        type: item.file.fileType,
        size: item.file.fileSize,
        public: true,
      });
      if (resp.isSuccess) {
        const data = resp.data.url.fields;
        const obj = Object.assign({}, data, {
          file: item.file.fileInitial,
        });
        const formData = new FormData();
        for (const key in obj) {
          if (undefined === obj[key]) {
            continue;
          }
          formData.append(key, obj[key]);
        }
        const postFile = await services.api.file.postFile(resp.data.url.url, formData);
        if (postFile.status === 204) {
          const updateLicense = await services.api.user.updateLicense(id, {
            state: item.state,
            license: item.license,
            issuedDate: item.issuedDate,
            expirationDate: item.expirationDate,
            fileObjectKey: resp.data.url.fields.key,
          });
          if (updateLicense.isSuccess) {
            this.showEditLicense(false);
          }
        }
      }
    }

    await this.listLicenses();
  };

  public showEditLicense = (show: boolean, id?: any) => {
    id !== null
      ? this.setState({ showEditModal: show, licenseId: id })
      : this.setState({ showEditModal: show });
  };

  public componentDidMount = () => {
    this.listLicenses();
  };

  public listLicenses = async () => {
    this.props.checkAuthentication();
    const response = await trackPromise(services.api.user.listUserLicenses(), 'licenses-area');
    if (response.isSuccess) {
      for (const item of response.data) {
        if (item.file) {
          const avatarUrl = await services.api.file.getDownloadFileUrl(item.file.key);
          item.file.file = avatarUrl;
        }
      }
      this.setState({
        licenses: response.data,
      });
    } else {
      console.error(response);
    }
  };

  public render() {
    return (
      <>
        <Grid stackable={true} style={{ width: '100%' }} className="licenses-grid">
          <LoadingSpiner area="licenses-area" />
          <Grid.Row columns={1} only="computer">
            <Grid.Column className="licenses-column">
              <Form>
                {this.state.licenses.length === 0 ? (
                  <Form.Input
                    name="licenses"
                    placeholder="Nothing Added"
                    instantValidation={false}
                    className="form-input readonly-input"
                    readOnly={true}
                  />
                ) : (
                  <div>
                    {this.state.licenses.map((el: any, index: number) => (
                      <LicenseItem
                        item={el}
                        key={index}
                        id={index}
                        editLicense={this.showEditLicense}
                        deleteLicense={this.deleteLicense}
                        mode="license"
                        download={this.props.download}
                      />
                    ))}
                  </div>
                )}
                <Form.Input
                  name="licenseFile"
                  hidden={true}
                  style={{ display: 'none' }}
                  readOnly={true}
                />
                <Button ref={this.sumbitRef} type="submit" style={{ display: 'none' }} />
              </Form>
              <div style={{ width: '100%' }}>
                <AddLicenseModal getLicense={this.getLicense} mode="license" />
              </div>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={16} only="tablet mobile">
            <Grid.Column className="licenses-column">
              <Form>
                {this.state.licenses.length === 0 ? (
                  <Form.Input
                    name="licenses"
                    placeholder="Nothing Added"
                    instantValidation={false}
                    className="form-input readonly-input"
                    readOnly={true}
                  />
                ) : (
                  <div>
                    {this.state.licenses.map((el: any, index: number) => (
                      <LicenseItem
                        item={el}
                        key={index}
                        id={index}
                        editLicense={this.showEditLicense}
                        deleteLicense={this.deleteLicense}
                        mode="license"
                        download={this.props.download}
                      />
                    ))}
                  </div>
                )}
                <Form.Input
                  name="licenseFile"
                  hidden={true}
                  style={{ display: 'none' }}
                  readOnly={true}
                />
                <Button ref={this.sumbitRef} type="submit" style={{ display: 'none' }} />
              </Form>
              <div style={{ width: '100%' }}>
                <AddLicenseModal getLicense={this.getLicense} mode="license" />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <EditLicenseModal
          show={this.state.showEditModal}
          editLicense={this.editLicense}
          showModal={this.showEditLicense}
          item={this.state.licenses[this.state.licenseId]}
          mode="license"
        />
      </>
    );
  }
}

const mapStateToProps = (state: MyTypes.RootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      checkAuthentication: accountActions.checkAuthentication,
      changeRegisterStore: accountActions.changeRegisterStore,
      changeProgressValue: accountActions.changeProgressValue,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileLicenses);
